import Api from '.';
import qs from 'qs';

const DpsEntryAPI = {
  async getAllDpsEntries(params) {
    return Api.get(`/dps-entries/all?${qs.stringify(params)}`);
  },
  async getAllDpsEntriesDetailed(params) {
    return Api.get(`/dps-entries/all-detailed?${qs.stringify(params)}`);
  },
  async getAllDpsEntriesAgent(params) {
    return Api.get(`/dps-entries/agent-all?${qs.stringify(params)}`);
  },
  async getRandomDpsEntries() {
    return Api.get('/dps-entries');
  },
  async updateDpsEntry(data) {
    return Api.post('/dps-entries/update', { data });
  },
  async createDpsEntry(data) {
    return Api.post('/dps-entries/create', { data });
  },
  async deleteDpsEntry(data) {
    return Api.post('/dps-entries/delete', { data });
  }
};

export default DpsEntryAPI;
